import { defineStore } from 'pinia';
import { ref } from 'vue';
import { ALERT_TYPES } from '@/utils/constants';

export const useAlertStore = defineStore('alert', () => {

  const isVisible = ref(false);
  const message = ref('');
  const header = ref('');
  const alertType = ref(ALERT_TYPES.Info);

  /**
   * Shows the alert dialog with specified message and header.
   *
   * @param {string} newMessage - The message to display.
   * @param {string} [newHeader] - The header/title of the alert.
   * @param {string} [type] - The type of alert to display.
   */
  function showAlert(newHeader, newMessage, type) {
    header.value = newHeader;
    message.value = newMessage;
    isVisible.value = true;
    alertType.value = type;
  }

  /**
   * Displays an informational alert with the specified header and message.
   *
   * @param {string} newHeader - The header text for the alert.
   * @param {string} newMessage - The message text for the alert.
   */
  function showInfoAlert(newHeader, newMessage) {
    showAlert(newHeader, newMessage, ALERT_TYPES.Info);
  }

  /**
   * Displays an error alert with the specified header and message.
   *
   * @param {string} newHeader - The header text for the error alert.
   * @param {string} newMessage - The message text for the error alert.
   */
  function showErrorAlert(newHeader, newMessage) {
    showAlert(newHeader, newMessage, ALERT_TYPES.Error);
  }
  /**
   * Displays a warning alert with the specified header and message.
   *
   * @param {string} newHeader - The header text for the warning alert.
   * @param {string} newMessage - The message text for the warning alert.
   */
  function showWarningAlert(newHeader, newMessage) {
    showAlert(newHeader, newMessage, ALERT_TYPES.Warning);
  }
  /**
   * Displays a success alert with the specified header and message.
   *
   * @param {string} newHeader - The header text for the success alert.
   * @param {string} newMessage - The message text for the success alert.
   */
  function showSuccessAlert(newHeader, newMessage) {
    showAlert(newHeader, newMessage, ALERT_TYPES.Success);
  }

  /**
   * Hides the alert dialog and clears message and header.
   */
  function hideAlert() {
    isVisible.value = false;
    message.value = '';
    header.value = '';
    alertType.value = ALERT_TYPES.Info;
  }

  return {
    isVisible,
    message,
    header,
    alertType,

    showAlert,
    showInfoAlert,
    showErrorAlert,
    showWarningAlert,
    showSuccessAlert,
    hideAlert,
  };
});